import {
  ApplicationConfig,
  APP_INITIALIZER,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthService } from '@shared/services/auth.service';
import { EmbeddedService } from '@shared/services/embedded.service';
import { TranslateService } from '@ngx-translate/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@shared/interceptors/auth.interceptor';
import { loaderInterceptor } from '@shared/interceptors/loader.interceptor';
import { errorInterceptor } from '@shared/interceptors/error.interceptor';
import { TranslateLoader, TranslateModule, MissingTranslationHandler } from '@ngx-translate/core';
import { importProvidersFrom } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { CustomTranslateLoader } from '@shared/utils/custom-translate-loader';
import { CustomMissingTranslationHandler } from '@shared/utils/custom-missing-translation-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideAnimations(),
    provideHttpClient(withInterceptors([loaderInterceptor, authInterceptor, errorInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoader
        },
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: CustomMissingTranslationHandler
        },
        defaultLanguage: 'es'
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService, translate: TranslateService, embedded: EmbeddedService) => () =>
        authService.initialize().then(() => {
          embedded.initialize();
          return firstValueFrom(translate.use('es'));
        }),
      deps: [AuthService, TranslateService, EmbeddedService],
      multi: true
    }
  ]
};
